import AWS from 'aws-sdk';

class DynamoService {
  constructor() {
    // Log environment variables for debugging
    console.log('🔧 DynamoService Environment Configuration:');
    console.log('   REACT_APP_AWS_REGION:', process.env.REACT_APP_AWS_REGION || 'eu-central-1');
    console.log('   REACT_APP_AWS_ACCESS_KEY_ID:', process.env.REACT_APP_AWS_ACCESS_KEY_ID ? '***SET***' : 'NOT SET');
    console.log('   REACT_APP_AWS_SECRET_ACCESS_KEY:', process.env.REACT_APP_AWS_SECRET_ACCESS_KEY ? '***SET***' : 'NOT SET');
    
    // Debug: Log all environment variables starting with REACT_APP_
    console.log('🔍 All REACT_APP_ environment variables:');
    Object.keys(process.env)
      .filter(key => key.startsWith('REACT_APP_'))
      .forEach(key => {
        const value = process.env[key];
        const displayValue = key.includes('SECRET') || key.includes('KEY') 
          ? (value ? '***SET***' : 'NOT SET')
          : value;
        console.log(`   ${key}:`, displayValue);
      });
    
    // Configure AWS SDK with explicit environment variable credentials
    this.dynamodb = new AWS.DynamoDB.DocumentClient({
      region: process.env.REACT_APP_AWS_REGION || 'eu-central-1',
      accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
      secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
    });
    
    this.tableName = 'flink-bedrock-demo-spam';
    this.scoredFeedbackTableName = 'flink-bedrock-demo-scored-feedback';
  }

  /**
   * Fetch all blocked messages from DynamoDB
   */
  async getBlockedMessages() {
    try {
      const params = {
        TableName: this.tableName,
        // Scan the entire table since we want all blocked messages
        // In production, you might want to add pagination
        Limit: 100 // Limit to prevent large responses
      };

      const result = await this.dynamodb.scan(params).promise();
      
      console.log('Successfully fetched blocked messages:', {
        count: result.Items.length,
        scannedCount: result.ScannedCount
      });
      
      return {
        success: true,
        items: result.Items || [],
        count: result.Count,
        scannedCount: result.ScannedCount
      };
    } catch (error) {
      console.error('Error fetching blocked messages from DynamoDB:', error);
      return {
        success: false,
        error: error.message,
        items: []
      };
    }
  }

  /**
   * Fetch scored feedback entries from DynamoDB
   */
  async getScoredFeedback() {
    try {
      const params = {
        TableName: this.scoredFeedbackTableName,
        Limit: 100
      };

      const result = await this.dynamodb.scan(params).promise();

      console.log('Successfully fetched scored feedback:', {
        count: result.Items.length,
        scannedCount: result.ScannedCount
      });

      return {
        success: true,
        items: result.Items || [],
        count: result.Count,
        scannedCount: result.ScannedCount
      };
    } catch (error) {
      console.error('Error fetching scored feedback from DynamoDB:', error);
      return {
        success: false,
        error: error.message,
        items: []
      };
    }
  }

  /**
   * Verify DynamoDB connection and table
   */
  async verifyConnection() {
    try {
      const dynamodbClient = new AWS.DynamoDB({
        region: process.env.REACT_APP_AWS_REGION || 'eu-central-1',
        accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
      });

      const result = await dynamodbClient.describeTable({ TableName: this.tableName }).promise();
      return {
        success: true,
        tableStatus: result.Table.TableStatus,
        itemCount: result.Table.ItemCount
      };
    } catch (error) {
      console.error('Error verifying DynamoDB connection:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
}

const dynamoService = new DynamoService();
export default dynamoService;
